import { MenuIcon } from "@heroicons/react/solid";
import React, { useState } from "react";
import { NavLink } from "react-router-dom";
// import ButtonLink from "../../components/shared/ButtonLink";
const Links = [
	{
		pathName: "Accueil",
		path: "/",
	},
	{
		pathName: "Sujets",
		path: "/sujets",
	},
	// {
	// 	pathName: "Blog",
	// 	path: "/blog",
	// },
];

const Navbar = () => {
	const [showMenu, setShowMenu] = useState(false);
	return (
		<nav className="pt-2 pb-4 sm:flex sm:justify-between">
			<div className="text-4xl font-lobster  flex justify-between">
				<NavLink to="/">
					<span className="text-slate-900">Gandal</span>
				</NavLink>
				<button className="menu sm:hidden" onClick={() => setShowMenu(!showMenu)}>
					<MenuIcon className="w-6 h-6" />
				</button>
			</div>
			<div
				className={`${
					!showMenu && "hidden"
				} sm:flex sm:justify-between bg-slate-50 px-3 pb-3 rounded-sm shadow-md sm:bg-inherit sm:shadow-none sm:p-0`}
			>
				<ul className="text-lg text-slate-600 font-medium sm:space-x-5 xl:space-x-7 mt-2 sm:flex sm:justify-center">
					{Links?.map((item) => (
						<li className="hover:text-orange-500" key={item?.pathName}>
							<NavLink
								to={item?.path}
								className={({ isActive }) =>
									isActive ? "text-orange-500" : ""
								}
							>
								{item?.pathName}
							</NavLink>
						</li>
					))}
				</ul>
				{/* <div className="auth-btn-container mt-3 sm:ml-5 xl:ml-14">
					<ButtonLink pathname="/se-connecter" text="Connexion" />
				</div> */}
			</div>
		</nav>
	);
};

export default Navbar;
